import { useGetTermsConditionsQuery } from "@/app/features/config/configApiSlice";
import ConfigWrapper from "@/pages/configuration/components/ConfigWrapper";
import ShowHtmlContent from "@/pages/configuration/components/ShowHtmlContent";
import { CircularProgress, Typography } from "@mui/material";

function TermsAndConditionsPage() {
  const { data, isLoading, error } = useGetTermsConditionsQuery();

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Typography align="center" sx={{ mb: 3 }} variant="h3">
        Something went wrong
      </Typography>
    );
  }

  return (
    <ConfigWrapper title="Terms & Conditions">
      <ShowHtmlContent content={data.termsConditions.termsConditionsDetail} />
    </ConfigWrapper>
  );
}

export default TermsAndConditionsPage;
